import { Injectable } from '@angular/core';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAdsService {
  private readonly signupConversionSendTo = 'AW-17667757488/gmpNCIrQrswcELCr0uhB';

  reportSignupConversion(): void {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('event', 'conversion', {
      send_to: this.signupConversionSendTo,
      value: 1.0,
      currency: 'USD'
    });
  }
}
